let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("433Iu")).then(() => parcelRequire('6NfPG'));